import { createFileRoute } from '@tanstack/react-router';
import { CompaniesScreen } from '../../../../features/companies/companies-screen';

/**
 * Firmele grupului stau sub `/setari`, nu la rădăcină: se administrează rar și aparțin
 * aceleiași zone ca nomenclatoarele. Selectorul de firmă activă — care se folosește des —
 * e în sidebar, nu aici.
 *
 * `?firma=<id>`, cu care avizul din facturare deschidea sertarul firmei (#201), nu mai există:
 * linkul duce acum direct la `/setari/firme/$companyId?tab=financiar` (#207).
 */
export const Route = createFileRoute('/_authenticated/setari/firme/')({
  component: CompaniesScreen,
});
